export default __webpack_public_path__ + "static/tall-maze2-1397d23f57eeb1c7f11e34f4cc195e0a.webp";